import { createContext, useContext } from 'react';

/**
 * Tracks whether the sidebar should show expanded UI (wordmark, labels, full collapse headers).
 * True when layout mode is `full`, or when mode is `compact` and the sidebar is hovered (peek-open).
 */
const SidebarVisualContext = createContext({
  isSidebarExpanded: true,
});

export function useSidebarVisual() {
  return useContext(SidebarVisualContext);
}

export default SidebarVisualContext;
